import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const provinceSlice = createSlice({
  name: "service",
  initialState: initialState,
  reducers: {
    setProvinces: (state, action) => {
      return [...action.payload];
    },
  },
});

export const { setProvinces } = provinceSlice.actions;

export default provinceSlice.reducer;
